import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useState, useRef, useEffect } from 'react';

export default function DashboardNavbar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <nav className="w-full px-4 md:px-6 py-3 bg-white border-b border-stone-200 flex items-center justify-between sticky top-0 z-50">
      <div className="flex items-center gap-4">
        <Link to="/dashboard" className="text-xl font-bold text-stone-800 tracking-tight">
          ProLog
        </Link>
        <div className="flex items-center gap-1">
          <Link
            to="/dashboard"
            className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-stone-600 hover:text-stone-900 hover:bg-stone-100 rounded-lg transition-all"
          >
            <i className="ri-dashboard-line"></i>
            Dashboard
          </Link>
          <Link
            to="/settings"
            title="Ayarlar"
            aria-label="Ayarlar"
            className="flex shrink-0 items-center justify-center w-11 h-11 text-stone-700 hover:text-stone-900 hover:bg-stone-100 rounded-lg transition-all border border-stone-200 hover:border-stone-300"
          >
            <i className="ri-settings-4-line text-2xl leading-none" />
          </Link>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="hidden sm:block text-sm text-stone-500">
          {user?.email}
        </span>

        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="w-9 h-9 flex items-center justify-center bg-stone-100 rounded-full hover:bg-stone-200 transition-colors cursor-pointer"
          >
            <i className="ri-user-line text-stone-600"></i>
          </button>

          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-stone-200 py-2">
              <div className="px-4 py-2.5 border-b border-stone-100 sm:hidden">
                <p className="text-sm text-stone-800 truncate">{user?.email}</p>
              </div>
              <button
                onClick={handleSignOut}
                className="w-full px-4 py-2.5 text-left text-sm text-red-600 hover:bg-red-50 transition-colors cursor-pointer flex items-center"
              >
                <i className="ri-logout-box-r-line mr-2"></i>
                Çıkış Yap
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}